import axios from '@/utils/request'

export default {
    getProductReport: data => axios({ url: '/api/report/productReport', method: 'POST', data }),//产品统计
    getProductReportVirtualWarehouse: params => axios({ url: '/api/product/virtualWarehouse/list', method: 'get', params }),//虚拟仓库列表
}